import { IEntity } from '@pf/shared-common';
import {
    ContainerFragment,
    Currency,
    InventoryBundleCondition,
    InventoryBundleInstanceFragment,
    InventoryBundleReservation,
    InventoryBundleSearchRequestParams,
    InventoryBundleStatus,
    InventoryBundleViewModelCreateBody,
    InventoryBundleViewModelRead,
    ItemFragment,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import {
    CustomFieldDto,
    ICustomerFragmentDto,
    IVendorFragmentDto,
} from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { StatusOptions } from '@pf/shared-ui';

export type InventoryBundleRead = InventoryBundleViewModelRead & IEntity;
export type InventoryBundleCreate = InventoryBundleViewModelCreateBody;
export type InventoryBundleSearchParams = InventoryBundleSearchRequestParams;

export class InventoryBundleDto implements IWarehouseEntity {
    constructor(data: Partial<InventoryBundleDto>) {
        Object.assign(this, data);
    }

    get name() {
        return `${this.item?.name} - ${this.availableQuantity} available | ${this.reservedQuantity} reserved`;
    }

    id!: string;
    warehouse!: WarehouseFragment;

    condition?: InventoryBundleCondition;
    inventoryBundleReservations?: Array<InventoryBundleReservation> | null;
    totalQuantity?: number;
    averageUnitCost?: Currency;
    status?: InventoryBundleStatus;
    item?: ItemFragment;
    container?: ContainerFragment;
    customer?: ICustomerFragmentDto;
    vendor?: IVendorFragmentDto;
    readonly reservedQuantity?: number;
    readonly availableQuantity?: number;
    inventoryBundleInstances?: Array<InventoryBundleInstanceFragment> | null;
    customFields?: CustomFieldDto[];
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    resourceAuth?: ResourceAuth;
}

// {
//     [ProjectStatus.Pending]: {
//         status: 'info',
//             label: 'Pending',
//     },
//     [ProjectStatus.Picking]: {
//         status: 'primary',
//             label: 'Picking',
//     },
//     [ProjectStatus.Picked]: {
//         status: 'success',
//             label: 'Picked',
//     },
//     defaultOption: {
//         label: '',
//     },
// }

export const InventoryBundleStatusOptions: StatusOptions = {
    [InventoryBundleStatus.Received]: {
        label: 'Received',
        color: '#52c41a', // Green (success)
    },
    [InventoryBundleStatus.Available]: {
        label: 'Available',
        color: '#5faff3', // Light Blue
    },
    [InventoryBundleStatus.Unavailable]: {
        label: 'Unavailable',
        color: '#ff4d4f', // Red (danger)
    },
    [InventoryBundleStatus.Reserved]: {
        label: 'Reserved',
        color: '#faad14', // Orange (warning)
    },
    [InventoryBundleStatus.Picked]: {
        label: 'Picked',
        color: '#1890ff', // Blue (info)
    },
    [InventoryBundleStatus.Packed]: {
        label: 'Packed',
        color: '#8c8c8c', // Grey (secondary)
    },
    defaultOption: {
        label: 'Unknown',
        color: '#808080', // Standard Grey
    },
};
